import React, { Component } from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import { withStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';
import get from 'lodash.get';
import { Grid, Typography } from '@material-ui/core';

import { RULE_ASSIGNMENT_FORM, RULE_ASSIGNMENT_TYPE, RULE_GROUP } from 'yeself-common/enum/RuleEnum';
import { FEATURE_FLAG_NAMES } from 'yeself-common/typings/FeatureFlags';
import { GUIDE_SUB_TYPE } from 'yeself-common/ModelConstant';

import { selectFeatureFlags } from 'yeself-client-common/featureFlags/FeatureFlagsSelector';

import Rules from 'yeself-client-common/form/rules/components/Rules';
import Feature from 'yeself-client-common/featureFlags/components/Feature';

import { doNotStartAutomaticallyRuleFilter } from 'yeself-client-common/rules/Rules';
import { ruleTypesByGroup } from 'yeself-client-common/form/rules/Rules';

import {
    selectFallbackLanguage,
    selectCompanyId,
} from 'Console/data/applicationDetail/settings/SettingsSelector';

import {
    selectApplicationGuideNames,
    selectApplicationGuidesList,
    selectInteractionCollectorNodeNames,
    selectAttributeNames,
    selectContextOptions,
} from 'Console/data/applicationDetail/guides/selectors';
import {
    fetchGuideRules,
    fetchAttributesForRuleRequest,
    fetchApplicationGuides,
    fetchContextOptionsForRuleRequest,
} from 'Console/data/applicationDetail/guides/actions';
import { selectContentLanguageCode } from 'Console/data/app/selectors';

const styles = (theme) => ({
    root: {
        padding: 0,
    },
});

const RenderRules = ({ input, options, assignmentsEnabled, isPlaylistSubType }) => (
    <Rules
        options={options}
        onChange={input.onChange}
        value={input.value}
        assignments={{
            enabled: assignmentsEnabled,
            defaultValue: isPlaylistSubType
                ? [{ type: RULE_ASSIGNMENT_TYPE.CONTEXT_HELP, form: RULE_ASSIGNMENT_FORM.INVISIBLE }]
                : [],
        }}
    />
);

class GuidesRulesTab extends Component {
    componentDidMount() {
        const {
            guide,
            fetchGuideRules,
            fetchAttributesForRuleRequest,
            fetchContextOptionsForRuleRequest,
            companyId,
        } = this.props;

        fetchGuideRules(guide.id);
        fetchAttributesForRuleRequest();

        if (companyId) {
            fetchContextOptionsForRuleRequest();
        }
    }

    handleRulesOnChange = (ruleGroup, rules) => {
        const {
            form: { setFieldsValue },
        } = this.props;

        setFieldsValue({
            [ruleGroup]: rules,
        });
    };

    render() {
        const {
            classes,
            guide,
            form: { getFieldDecorator, getFieldValue },
            guideNamesOptions,
            attributeNamesOptions,
            interactionCollectorNodeNamesOptions,
            featureFlags,
            contextOptions,
        } = this.props;

        getFieldDecorator(RULE_GROUP.IDENTITY, {
            initialValue: get(guide, `graph.metadata.rulesDefinition.${RULE_GROUP.IDENTITY}`, []),
            preserve: true,
        });

        getFieldDecorator(RULE_GROUP.VISITOR, {
            initialValue: get(guide, `graph.metadata.rulesDefinition.${RULE_GROUP.VISITOR}`, []),
            preserve: true,
        });

        const identityRules = getFieldValue(RULE_GROUP.IDENTITY).filter(
            doNotStartAutomaticallyRuleFilter
        );
        const visitorRules = getFieldValue(RULE_GROUP.VISITOR).filter(doNotStartAutomaticallyRuleFilter);

        return (
            <Grid container direction="row" justify="space-between">
                <Feature name={FEATURE_FLAG_NAMES.PROFILE_RULES}>
                    <Grid item xs={12} lg={6}>
                        <Typography variant="subtitle1" gutterBottom>
                            <FormattedMessage
                                id="SettingsRules.rules.group.profile"
                                defaultMessage="Profile"
                            />
                        </Typography>

                        <RenderRules
                            input={{
                                value: identityRules,
                                onChange: (rules) => {
                                    this.handleRulesOnChange(RULE_GROUP.IDENTITY, rules);
                                },
                            }}
                            options={{
                                guideNames: guideNamesOptions,
                                attributeNames: attributeNamesOptions,
                                interactionCollectorNodeNames: interactionCollectorNodeNamesOptions,
                                ruleType: ruleTypesByGroup(RULE_GROUP.IDENTITY, featureFlags),
                            }}
                            assignmentsEnabled
                            isPlaylistSubType={guide.subType === 'playlist'}
                        />
                    </Grid>
                </Feature>
                <Grid item xs={12} lg={6}>
                    <Typography variant="subtitle1" gutterBottom>
                        <FormattedMessage
                            id="SettingsRules.rules.group.visitor"
                            defaultMessage="Visitor"
                        />
                    </Typography>

                    <RenderRules
                        input={{
                            value: visitorRules,
                            onChange: (rules) => {
                                this.handleRulesOnChange(RULE_GROUP.VISITOR, rules);
                            },
                        }}
                        options={{
                            guideNames: guideNamesOptions,
                            attributeNames: attributeNamesOptions,
                            interactionCollectorNodeNames: interactionCollectorNodeNamesOptions,
                            ruleType: ruleTypesByGroup(RULE_GROUP.VISITOR, featureFlags),
                            contextResponse: contextOptions,
                        }}
                        assignmentsEnabled
                        isPlaylistSubType={guide.subType === GUIDE_SUB_TYPE.PLAYLIST}
                    />
                </Grid>
            </Grid>
        );
    }
}

export default connect(
    (state, { guide: { id } }) => ({
        guides: selectApplicationGuidesList(state),
        guideNamesOptions: selectApplicationGuideNames(state, id),
        attributeNamesOptions: selectAttributeNames(state),
        interactionCollectorNodeNamesOptions: selectInteractionCollectorNodeNames(state),
        contentLanguage: selectContentLanguageCode(state),
        fallbackLanguage: selectFallbackLanguage(state),
        featureFlags: selectFeatureFlags(state),
        contextOptions: selectContextOptions(state),
        companyId: selectCompanyId(state),
    }),
    {
        fetchApplicationGuides,
        fetchGuideRules,
        fetchAttributesForRuleRequest,
        fetchContextOptionsForRuleRequest,
    }
)(withStyles(styles)(injectIntl(GuidesRulesTab)));
